<template>
    <div class='home-container'>
        <el-tabs v-model='activeTab' type='card'>
            <el-tab-pane :label="$t('home.personalInfo') || '个人信息'" name='account'>
                <account-view />
            </el-tab-pane>
            <el-tab-pane :label="$t('home.giftCodeRedeem') || '礼包码兑换'" name='giftCode'>
                <gift-code-redeem />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import AccountView from '@view/account/index.vue';
import GiftCodeRedeem from '@view/home/GiftCodeRedeem.vue';

export default defineComponent({
    name: 'HomeIndex',
    components: {
        AccountView,
        GiftCodeRedeem
    },
    data() {
        return {
            activeTab: 'account',
            validTabs: ['account', 'giftCode']
        };
    },
    created() {
        const tab = this.$route.query.tab;
        if (tab && this.validTabs.includes(tab)) {
            this.activeTab = tab;
        }
    }
});
</script>

<style scoped>
.home-container {
    padding: 0;
}
</style>